import {Inject, Injectable} from '@angular/core';
import {API_URL} from "lib-base";
import {HttpClient} from "@angular/common/http";
import {IGetDetalleSolicitud, IPqrsdRequest} from "../../shared/interfaces/pqrsdf";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SolicitudPqrsdService {
  private baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/solicitudes-pqrsd`;
  }

  crearSolicitud(solicitud: IPqrsdRequest, file?: File): Observable<any> {
    const url = `${this.baseUrl}/public/registrar`;
    const formData: FormData = new FormData();
    if (file)
      formData.append('adjunto', file);
    formData.append('request', new Blob([JSON.stringify(solicitud)], {type: 'application/json'}));
    return this.http.post(url, formData);
  }


  getDetalleSolicitud(radicado: string): Observable<IGetDetalleSolicitud> {
    const url = `${this.baseUrl}/public/detalle-solicitud/${radicado}`;
    return this.http.get<IGetDetalleSolicitud>(url);
  }
}
